export const contactInfo = {
    mailTo: "brian@walltowallfurniture.com",
    phone: "(509) 876-8618",
    page: "/page/contact",
    facebook: "https://www.facebook.com/wall2wallfurnitureww",
    instagram: "https://www.instagram.com/wall2wallfurnitureww/",
    twitter: "",
    pinterest: "",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: false,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: 'Please use the contact form to ask us a question or leave us a comment. We will get back soon.',
    callUs: {
        title: 'Call Us',
        subtitle: 'Our friendly and knowledgeable staff would be delighted to take your call.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: "Wall 2 Wall Furniture & Mattress is Walla Walla's only locally owned furniture & mattress store!",
    where: {
        title: 'Wall 2 Wall Furniture & Mattress',
        subtitle: '527 East Main Street, Walla Walla, Washington',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2767.943838425288!2d-118.333282!3d46.07216100000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54a26a8bd9df66bd%3A0x2373a2c55dde1671!2sWall%202%20Wall%20Furniture%20%26%20Mattress!5e0!3m2!1sen!2suy!4v1702927892165!5m2!1sen!2suy'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Friday 10:00am - 5:30pm / Saturday 10:00am - 5:00 pm / Sundays Closed '
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}